import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { ChartActionType, IChartActionType } from '@src/slide/domain/ui-model/element-modeles/property/chart/constant';

const specialEditorOperationMapping: Record<IChartActionType, string> = {
    [ChartActionType.FONTFAMILY]: 'font-family',
    [ChartActionType.BOLD]: 'font-bold',
    [ChartActionType.ITALIC]: 'font-italic',
};

// 是否图表标题有编辑焦点
export function isChartTitleInFocus(model: IChartModel): boolean {
    return !!model.editorInstance?.isEditing;
}

function transformChartActionToEditorOperation(
    chartAction: IChartActionType,
    value: any,
): { operation: string; value: any} | undefined {
    // 处理一下两边不一样的key，比如action里是fontfamily，operation里面是font-family
    const operation = specialEditorOperationMapping[chartAction] || chartAction;

    return {
        operation,
        // 处理方式
        value,
    };
}

export function updateTitleStyle(model: IChartModel, action: IChartActionType, value) {
    // 有焦点执行选区更新
    if (isChartTitleInFocus(model)) {
        const result = transformChartActionToEditorOperation(action, value);
        if (result) {
            model.editorInstance?.operations(result.operation, result.value, {});
        }

        return;
    }

    // 执行整体model更新
    const title = model.chartProperty.chartTitle;
    title?.updateFontStyle(action, value);
}

// eslint-disable-next-line complexity
export function getTitleStyle(model: IChartModel, action: IChartActionType): any {
    // 有焦点执行选区更新
    if (isChartTitleInFocus(model)) {
        const styles = model.editorInstance?.getAllStyles();
        switch (action) {
            case ChartActionType.FONT_SIZE:
                return styles?.fontSize || 18;
            case ChartActionType.FONTFAMILY:
                return styles?.fontFamily
                    || styles?.fonts?.ea
                    || styles?.fonts?.latin
                    || '';
            case ChartActionType.FONT_COLOR:
                return styles?.tdColor || '';
            case ChartActionType.BOLD:
                return styles?.fontWeight === 'bold';
            case ChartActionType.ITALIC:
                return styles?.fontStyle === 'italic';
        }
    }

    const title = model.chartProperty.chartTitle!;
    switch (action) {
        case ChartActionType.FONT_SIZE:
            return title.getTextFontSize();
        case ChartActionType.FONTFAMILY:
            return title.getTextFontFamily();
        case ChartActionType.FONT_COLOR:
            return title.getTextFontColor();
        case ChartActionType.BOLD:
            return title.getTextFontBold();
        case ChartActionType.ITALIC:
            return title.getTextFontItalic();
    }
}
